import * as Colors from 'material-ui/styles/colors';
import * as React from 'react';
import * as _ from 'lodash';
import Button, {ButtonProps} from '@material-ui/core/Button';
import {withStyles, WithStyles, createStyles} from '@material-ui/core/styles';
const classNames = require('classnames');
import {capitalize} from '@material-ui/core/utils/helpers';
import {stringToDashed} from 'cl-automation-utils';

const ARROW_SIZE = 20;

export const BUTTONS_TYPES: {[type: string]: ButtonProps['variant']} = {FLAT: 'text', RAISED: 'contained'};

interface baseProps {
  variant?: ButtonProps['variant'];
  withArrow?: boolean;
  color?: 'secondary' | 'inherit'; // at the moment we support 2 colors, but if this is going to be infrastructure component it should support everything the Button supports
  largeButtons?: boolean;
}

interface ToggleButtonProps extends baseProps {
  label: string;
  onChange: (event: object) => void;
  checked: boolean;
}

interface ToggleButtonGroupProps extends baseProps {
  buttons: ToggleButtonProps[];
  withArrow?: boolean;
}

type ToggleButtonGroupPropsWithStyles = ToggleButtonGroupProps & WithStyles<'root'>;

class ToggleButtonGroup extends React.PureComponent<ToggleButtonGroupPropsWithStyles> {
  static defaultProps: Partial<ToggleButtonGroupProps> = {
    variant: BUTTONS_TYPES.RAISED,
    withArrow: false,
    color: 'inherit',
    largeButtons: false,
  };

  render() {
    const {buttons, classes, ...other} = this.props;
    const className = classNames(classes.root);
    return (
      <div className={className}>
        {_.map(buttons, (button, index) => {
          const {onChange, label, checked} = button;
          return (
            <ToggleButton
              key={index + '_single_toggle_button'}
              onChange={onChange}
              label={label}
              checked={checked}
              {...other}
            />
          );
        })}
      </div>
    );
  }
}
type ToggleButtonClassKeys = 'root' | 'withArrow' | 'colorSecondaryChecked' | 'colorUnchecked';

const toggleButtonStyles = theme =>
  createStyles({
    root: {
      textTransform: 'none' as 'none',
      margin: 0,
      '& + &::before': {
        content: '""',
        width: 1,
        left: 0,
        height: '100%',
        position: 'absolute',
        backgroundColor: Colors.grey300,
      },
    },
    withArrow: {
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: -ARROW_SIZE / 2,
        overflow: 'hidden',
        width: ARROW_SIZE,
        height: ARROW_SIZE,
        backgroundColor: theme.palette.secondary.main,
        transition: 'all 200ms ease-in',
        clipPath: `polygon(50% 50%, 100% 50%, 50% 100%, 0 50%)`,
      },
    },
    colorUnchecked: {
      color: Colors.black,
      backgroundColor: Colors.white,
    },
    colorSecondaryChecked: {
      color: Colors.white,
      backgroundColor: theme.palette.secondary.main + '!important',
    },
  });
const ToggleButton = withStyles<ToggleButtonClassKeys, {}>(toggleButtonStyles)(
  (props: ToggleButtonProps & WithStyles<typeof toggleButtonStyles>) => {
    const {variant, onChange, label, withArrow, checked, color, largeButtons, classes} = props;
    const className = classNames(classes.root, {
      [classes.withArrow]: checked && withArrow,
      [classes.colorUnchecked]: !checked,
      [classes[`color${capitalize(color) + 'Checked'}`]]: checked && color !== 'inherit',
    });
    return (
      <Button
        id={`cla-btn-${stringToDashed(label)}`}
        variant={variant}
        onClick={onChange}
        className={className}
        size={largeButtons ? 'large' : undefined}
      >
        {label}
      </Button>
    );
  }
);

export default withStyles<'root', {}>(() => ({
  root: {
    borderStyle: 'solid',
    borderColor: Colors.grey300,
    borderWidth: 1,
    display: 'flex',
    justifyContent: 'space-between',
  },
  '@media (max-width: 767px)': {
    root: {
      width: 'max-content',
    },
  },
}))(ToggleButtonGroup);
